import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import MainHeader from '../../components/templates/MainHeader';
import routeConstants from '../../utils/routeConstants';
import { signOut } from '../../actions/userActions';

import '../styles/HeaderContainerTemplate.scss';

class HeaderContainerTemplate extends React.Component {
  constructor() {
    super();

    this.routeToJoin = this.routeTo.bind(this, routeConstants.SIGNUP_ROUTE);
    this.routeToSignIn = this.routeTo.bind(this, routeConstants.SIGNIN_ROUTE);
    this.routeToHome = this.routeTo.bind(this, routeConstants.HOME_ROUTE);
    this.logout = this.logout.bind(this);
  }

  routeTo(route) {
    this.props.dispatch(push(route));
  }

  logout() {
    this.props.signOut();
    this.routeTo(routeConstants.SESSIONS_ROUTE);
  }

  render() {
    return (
      <div className="header-container-template">
        <div className="main-header-wrapper">
          <MainHeader
            isLogged={ this.props.loggedIn }
            userFullName={ `${this.props.user.first_name || ''} ${this.props.user
              .last_name || ''}` }
            routeToJoin={ this.routeToJoin }
            routeToSignIn={ this.routeToSignIn }
            signOut={ this.logout }
            routeToHome={ this.routeToHome }
          />
        </div>
        <div className="content">{this.props.children}</div>
      </div>
    );
  }
}

HeaderContainerTemplate.propTypes = {
  children: PropTypes.node,
  loggedIn: PropTypes.bool,
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string
  }),
  dispatch: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired
};

HeaderContainerTemplate.defaultProps = {
  children: null,
  loggedIn: false,
  user: {
    first_name: '',
    last_name: ''
  }
};

const mapStateToProps = state => ({
  loggedIn: state.auth.loggedIn,
  user: state.auth.user
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  signOut: () => dispatch(signOut())
});

export default connect(mapStateToProps, mapDispatchToProps)(
  HeaderContainerTemplate
);



// WEBPACK FOOTER //
// ./src/containers/templates/HeaderContainerTemplate.js